import { jsx as _jsx } from "react/jsx-runtime";
import Badge from "module/common/components/Badge/Badge";
import { actionStatusClassName, actionStatusTone } from "../util";
export function StatusBadge(_a) {
    var status = _a.status;
    return (_jsx(Badge, { tone: actionStatusTone(status), withDot: true, className: actionStatusClassName(status), children: status.toLowerCase() }));
}
